// Libraries
var React = require('react');
var dateFormat = require('dateformat');
var PubSub = require('pubsub-js');

var $ = require('jquery');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');
var nikeLogo = require('images/nike_logo.svg');

// Styles
require('../Hero.scss');
require('./MatchDayCentreHero.scss');

// Components
var CallToAction = require('CallToAction/CallToAction');
var LocalTimeConverter = require('LocalTimeConverter/LocalTimeConverter');

// TODO:
// 1. make the hero's background image responsive with the difference sizes from json file

class MatchDayCentreHeroModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			kickOff: "",
			kickOffDay: "",
			isMatchOccurring: this.props.data.fixture.isMatchOccurring,
			showSelf: true,
			kickOffHours: '',
			kickOffMinutes: '',
			kickOffSeconds: '',
			showTimer: false,

			showPenalties: false,
			penaltyShootOutOccurring: false,
			awayCrestUrl: "",
			homeCrestUrl: "",
			penalties: [],
			penaltiesScore: "",

			latestResults: [],

			score: "",
			showAggregateScore: false,
			aggregateScore: ""
		};

		this.countDownInterval = null;
		this.scoreInterval = null;
	}

	componentDidMount = () => {

		//this.loadHighlights();
		this.loadLatestScores();
		this.scoreInterval = setInterval(()=> {
			//this.loadHighlights();
			this.loadLatestScores();
		}, 60000);

		this.countDown();
		this.countDownInterval = setInterval(()=> {
			this.countDown();
		}, 1000);
	}

	componentWillMount = _ => {
		this.image = this.props.data.fixture ? this.props.data.fixture.stadium.image : this.props.data.fallback.backgroundImage;
	}

	componentWillUnmount = () => {
		if(this.scoreInterval) {
			clearInterval(this.scoreInterval);
		}
	}

	countDown = () => {

		var currentTime = new Date();
		var kickOff = new Date(this.props.data.fixture.kickOff);
		var countDownBeginTime = new Date(this.props.data.fixture.kickOff);

		kickOff = LocalTimeConverter(kickOff);
		countDownBeginTime = LocalTimeConverter(countDownBeginTime);

		var isMatchOccurring = new Date() > kickOff && !this.props.data.fixture.isFullTime
		this.setState({ isMatchOccurring: isMatchOccurring });

		countDownBeginTime.setHours(countDownBeginTime.getHours() - this.props.data.hoursBeforeKickOffCountdown);

		if (currentTime > kickOff) {
			this.startMdc();
		}

		if (currentTime >= countDownBeginTime && kickOff >= currentTime) {

			const temp = Math.abs(kickOff.getTime() - currentTime.getTime());

			var countDownValue = dateFormat(temp, "HH MM ss", true);

			var countDownValueHours = dateFormat(temp, "HH", true);
			var countDownValueMinutes = dateFormat(temp, "MM", true);
			var countDownValueSeconds = dateFormat(temp, "ss", true);

			this.setState({ showTimer: !this.props.data.fixture.showKickOffOverrideText });
			this.setState({ kickOff: countDownValue });

			this.setState({ kickOffHours: countDownValueHours });
			this.setState({ kickOffMinutes: countDownValueMinutes });
			this.setState({ kickOffSeconds: countDownValueSeconds });


			if (countDownValue === "00:00:00") {
				this.startMdc();
				// if the hero isn't hiding, change the content to 'live' mode
				if (!this.props.data.hideDuringGame) {
					this.setState({ isMatchOccurring: true });
				}
			}
		} else {
			this.setState({ kickOffDay: dateFormat(kickOff, "dddd") });
			this.setState({ kickOff: dateFormat(kickOff, "dd mmmm HH:MM"), showTimer: false });
		}
	}

	startMdc = () => {
		if (this.props.data.hideDuringGame) {
			this.setState({ showSelf: false });
			PubSub.publish('StartMdc');
		}

		clearInterval(this.countDownInterval);
	}

	loadHighlights = () => {
		$.ajax({
			method: "GET",
			url: this.props.data.endpoints.find(x => x.name === "highlights").url
		})
			.done(data => {
				if (data && data.Items) {
					this.populatePenalties(data.Items);
				}
				if (data.HomeCrestUrl && data.AwayCrestUrl) {
					this.setState({
						homeCrestUrl: this.props.data.baseUrl + data.HomeCrestUrl,
						awayCrestUrl: this.props.data.baseUrl + data.AwayCrestUrl
					});
				}
			});
	}

	loadLatestScores = () => {
		$.ajax({
			method: "GET",
			url: this.props.data.endpoints.find(x => x.name === "latestScore").url
		})
			.done(data => {
				if (data) {
					this.populateLatestScores(data);
				}
			});
	}

	populatePenalties = (highlights, update) => {
		const isHomeAndScored = p => p.IsHome && p.Outcome === 'Scored';
		const isAwayAndScored = p => !p.IsHome && p.Outcome === 'Scored';

		if (highlights.some(x => x.HighlightType === "PenaltyShot")) {
			var penalties = this.state.penalties;
			var penaltiesToAdd = highlights.filter(x => x.HighlightType === "PenaltyShot");

			if (update) {
				penaltiesToAdd.forEach((current, index, array) => {
					if (penalties.findIndex(x => x.Id === current.Id) === -1) {
						penalties.push(current);
					}
				});
			} else {
				penalties = highlights.filter(x => x.HighlightType === "PenaltyShot");
			}

			var homePenaltyCount = penalties.filter(isHomeAndScored).length;
			var awayPenaltyCount = penalties.filter(isAwayAndScored).length;

			this.setState({
				showPenalties: true,
				penaltyShootOutOccurring: true,
				penalties: penalties,
				penaltiesScore: "(Pen " + homePenaltyCount + " - " + awayPenaltyCount + ")"
			});
		}
	}

	populateLatestScores = (data) => {
		this.setState({
			score: data.home.score + " - " + data.away.score,
			aggregateScore: data.home.aggregateScore + " - " + data.away.aggregateScore,
			showAggregateScore: (data.showAggregateScore && data.home.aggregateScore !== undefined && data.away.aggregateScore !== undefined)
		});
	}

	populateLatestResults = (data) => {
		this.setState({
			latestResults: data
		});
	}

	render() {
		let showMatchDayCentreLink = false;

		let headingText = "";
		if (this.state.isMatchOccurring) {
			showMatchDayCentreLink = true;
			headingText = "Now Live";
		} else if (this.props.data.fixture.isFullTime) {
			showMatchDayCentreLink = true;
			headingText = "Result";
		} else {
			headingText = "Next match";
		}

		return (
			<div data-bg={this.image.smallUrl + '*,*' + this.image.mediumUrl + '*,*' + this.image.largeUrl + '*,*' + this.image.extraLargeUrl} ref={(hero) => { this.hero = hero; }} className={"MatchDayCentreHero" + (this.state.showSelf ? "" : " hide")} id={this.props.data.id}>
				<div className="MatchDayCentreHero__outer-wrapper">
					<div className="MatchDayCentreHero__wrapper">
						<div className="MatchDayCentreHero__header">
							<h1>{headingText}</h1>
							{this.props.data.fixture.competition.lightCrest &&
								<img src={PlaceholderImg} data-src={this.props.data.fixture.competition.lightCrest.url} alt={this.props.data.fixture.competition.lightCrest.altText} />
							}
						</div>
						<p className="tags">
							<a href={this.props.data.fixture.tag.url} rel="nofollow">{this.props.data.fixture.tag.hashtag} </a>
						</p>

						{this.state.showTimer &&
							<p className="kickoff-countdown">Countdown to kick-off:</p>
						}

						{this.props.data.fixture &&
							<div>
								{this.props.data.fixture.showKickOffOverrideText && 
									<div class="MatchDayCentreHero__kickoff">
										<p>{this.props.data.fixture.kickOffOverrideText}</p>
									</div>
								}
								{!this.props.data.fixture.showKickOffOverrideText && 
									!this.state.isMatchOccurring &&
									<div>
										{!this.state.showTimer
											?
											<div className="MatchDayCentreHero__kickoff">
												<span>{this.state.kickOffDay}</span>
												<p>{this.state.kickOff}</p>
											</div>

											:

											<div className="MatchDayCentreHero__kickoff">
												<p className="sliced-time hours">
													<span className="sliced-time__wrapper">
														<span className="text">HOURS</span>
														<span>{this.state.kickOffHours}</span>
													</span>
												</p>
												<p className="sliced-time minutes">
													<span className="sliced-time__wrapper">
														<span className="text">MINUTES</span>
														<span>{this.state.kickOffMinutes}</span>
													</span>
												</p>
												<p className="sliced-time seconds">
													<span className="sliced-time__wrapper">
														<span className="text">SECONDS</span>
														<span>{this.state.kickOffSeconds}</span>
													</span>
												</p>
											</div>
										}
									</div>

								}

								{this.state.showTimer &&
									<div className="sponsor">
										<p>Presented by</p>
										<img src={nikeLogo} alt="" />
									</div>
								}

								<div className="MatchDayCentreHero__crests">
									<div className="home">
										{this.props.data.fixture.homeTeam.lightCrest &&
											<img src={PlaceholderImg} data-src={this.props.data.fixture.homeTeam.lightCrest.smallUrl} alt={this.props.data.fixture.homeTeam.lightCrest.altText} />
										}
										<p>{this.props.data.fixture.homeTeam.shortName}</p>
									</div>
									{(this.props.data.fixture.isFullTime || this.state.isMatchOccurring) &&
										<div className="score">{

											(!this.props.data.fixture.isFullTime) ? this.state.score :

												(this.props.data.fixture.homeScore !== null ? this.props.data.fixture.homeScore : "") +
												" - " +
												(this.props.data.fixture.homeScore !== null ? this.props.data.fixture.awayScore : "")
											}

											{(this.props.data.fixture.isFullTime && this.props.data.fixture.aggregateHomeScore !== "" && this.props.data.fixture.aggregateAwayScore !== null) ? (
												<span className="score-extra">
													(Agg {this.props.data.fixture.aggregateHomeScore} - {this.props.data.fixture.aggregateAwayScore})
													</span>
														) : (this.state.showAggregateScore ? <span className="score-extra">(Agg {this.state.aggregateScore})</span> : "")
											}

											{(this.props.data.fixture.isFullTime && this.props.data.fixture.penaltyHomeScore !== "" && this.props.data.fixture.penaltyAwayScore !== null) ? (
												<span className={"score-extra" + (this.props.data.fixture.aggregateAwayScore ? " score-extra-offset" : "")}>
													(Pen {this.props.data.fixture.penaltyHomeScore} - {this.props.data.fixture.penaltyAwayScore})
													</span>
											) : (this.state.penaltyShootOutOccurring &&
												<span className={"score-extra" + (this.state.showAggregateScore ? " score-extra-offset" : "")}>{this.state.penaltiesScore}</span>)
											}

										</div>
									}
									{!this.props.data.fixture.isFullTime && !this.state.isMatchOccurring &&
										<span>VS</span>
									}
									<div className="away">
										{this.props.data.fixture.awayTeam.lightCrest &&
											<img src={PlaceholderImg} data-src={this.props.data.fixture.awayTeam.lightCrest.smallUrl} alt={this.props.data.fixture.awayTeam.lightCrest.altText} />
										}
										<p>{this.props.data.fixture.awayTeam.shortName}</p>
									</div>
								</div>
								<div className="MatchDayCentreHero__stadium">
									<p>{this.props.data.fixture.competition.name}</p>
									<p className="location">{this.props.data.fixture.stadium.displayName}</p>
									{this.props.data.fixture.referee && <p className="referee">Referee: {this.props.data.fixture.referee}</p>}
								</div>
							</div>
						}
						{showMatchDayCentreLink ?
							(<p className="MatchDayCentreHero__action"><a href={this.props.data.fixture.matchDayCentreLink.url} className="c-button c-button--on-dark">{this.props.data.fixture.matchDayCentreLink.caption}</a></p>) :
							(
								this.props.data.fixture && this.props.data.fixture.buttonLink &&
								<p className="MatchDayCentreHero__action"><a href={this.props.data.fixture.buttonLink.url} className="c-button c-button--on-dark">{this.props.data.fixture.buttonLink.caption}</a></p>
							)}
						{/* {showMatchDayCentreLink ?
							(<CallToAction {...this.props.data.fixture.matchDayCentreLink} />) :
							(
								this.props.data.fixture && this.props.data.fixture.buttonLink &&
								<CallToAction {...this.props.data.fixture.buttonLink} />
							)} */}
						{!showMatchDayCentreLink && this.props.data.fixture && this.props.data.fixture.buttonLinkComment &&
							<div className="MatchDayCentreHero__description">
								<p>{this.props.data.fixture.buttonLinkComment}</p>
							</div>
						}
					</div>
					{this.props.data.fixture &&
						<div className="MatchDayCentreHero__desktop">
							<div className="MatchDayCentreHero__crests">
								<div className="home">
									{this.props.data.fixture.homeTeam.lightCrest &&
										<img src={PlaceholderImg} data-src={this.props.data.fixture.homeTeam.lightCrest.smallUrl} alt={this.props.data.fixture.homeTeam.lightCrest.altText} />
									}
									<p>{this.props.data.fixture.homeTeam.name}</p>
								</div>
								{(this.props.data.fixture.isFullTime || this.state.isMatchOccurring) &&
									<div className="score">{

										(!this.props.data.fixture.isFullTime) ? this.state.score :

											(this.props.data.fixture.homeScore !== null ? this.props.data.fixture.homeScore : "") +
											" - " +
											(this.props.data.fixture.homeScore !== null ? this.props.data.fixture.awayScore : "")
									}

										{(this.props.data.fixture.isFullTime && this.props.data.fixture.aggregateHomeScore !== "" && this.props.data.fixture.aggregateAwayScore !== null) ? (
											<span className="score-extra">
												(Agg {this.props.data.fixture.aggregateHomeScore} - {this.props.data.fixture.aggregateAwayScore})
														</span>
										) : (this.state.showAggregateScore ? <span className="score-extra">(Agg {this.state.aggregateScore})</span> : "")
										}

										{(this.props.data.fixture.isFullTime && this.props.data.fixture.penaltyHomeScore !== "" && this.props.data.fixture.penaltyAwayScore !== null) ? (
											<span className={"score-extra" + (this.props.data.fixture.aggregateAwayScore ? " score-extra-offset" : "")}>
												(Pen {this.props.data.fixture.penaltyHomeScore} - {this.props.data.fixture.penaltyAwayScore})
														</span>
										) : (this.state.penaltyShootOutOccurring &&
											<span className={"score-extra" + (this.state.showAggregateScore ? " score-extra-offset" : "")}>{this.state.penaltiesScore}</span>)
										}

	
									</div>
								}
								{!this.props.data.fixture.isFullTime && !this.state.isMatchOccurring &&
									<span>VS</span>
								}
								<div className="away">
									{this.props.data.fixture.awayTeam.lightCrest &&
										<img src={PlaceholderImg} data-src={this.props.data.fixture.awayTeam.lightCrest.smallUrl} alt={this.props.data.fixture.awayTeam.lightCrest.altText} />
									}
									<p>{this.props.data.fixture.awayTeam.name}</p>
								</div>
							</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

module.exports = MatchDayCentreHeroModule;



// WEBPACK FOOTER //
// ./src/components/Hero/MatchDayCentreHero/MatchDayCentreHeroModule.js